import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listMyGroups, createGroup } from '../utils/api'
import { C, gradient, fontStack, btn, input, card } from '../constant/theme'
import Navbar from '../Components/Navbar'

export default function Dashboard() {
  const navigate = useNavigate()
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [creating, setCreating] = useState(false)
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState(false)
  const [mobile, setMobile] = useState(window.innerWidth < 640)

  useEffect(() => {
    const onResize = () => setMobile(window.innerWidth < 640)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const load = async () => {
    setLoading(true)
    try {
      setGroups(await listMyGroups())
    } catch (e) {
      // axios interceptor handles retries; ignore here
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    load()
  }, [])

  const create = async (e) => {
    e.preventDefault()
    if (!name.trim()) { setNameError(true); return }
    setNameError(false)
    setCreating(true)
    try {
      const group = await createGroup({ name: name.trim() })
      navigate(`/groups/${group.id}/edit`)
    } finally {
      setCreating(false)
    }
  }

  return (
    <div style={S.root}>
      <Navbar variant="admin" />

      <main style={{ ...S.main, padding: mobile ? '20px 14px' : '28px 24px' }}>
        <h1 style={S.title}>Your trips</h1>

        <form onSubmit={create} style={S.createRow}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <label style={S.label}>Trip name</label>
            <input
              style={{ ...input, maxWidth: 360, borderColor: nameError ? '#e05252' : undefined }}
              placeholder="e.g. Goa Trip 2026"
              value={name}
              onChange={(e) => { setName(e.target.value); if (nameError) setNameError(false) }}
            />
            {nameError && <span style={{ fontSize: 12, color: '#e05252' }}>Please enter a trip name.</span>}
          </div>
          <button style={btn('primary')} disabled={creating} type="submit">{creating ? 'Creating…' : '+ Create trip'}</button>
        </form>

        {loading ? (
          <p style={S.muted}>Loading…</p>
        ) : groups.length === 0 ? (
          <div style={{ ...card, textAlign: 'center', color: C.textSoft }}>No trips yet — create your first one above.</div>
        ) : (
          <div style={S.grid}>
            {groups.map((g) => (
              <div key={g.id} style={S.cardItem} onClick={() => navigate(`/groups/${g.id}/edit`)}>
                <div style={{ ...S.cover, backgroundImage: g.coverImage?.url ? `url(${g.coverImage.url})` : gradient }} />
                <div style={{ padding: 14 }}>
                  <strong style={{ color: C.text, fontSize: 15 }}>{g.name}</strong>
                  <div style={S.meta}>{g.locationName || '—'}{g.startDate ? ` · ${g.startDate}` : ''}</div>
                  <a
                    href={`/g/${g.slug}`}
                    onClick={(e) => e.stopPropagation()}
                    target="_blank"
                    rel="noreferrer"
                    style={S.publicLink}
                  >
                    /g/{g.slug} ↗
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  )
}

const S = {
  root: { minHeight: '100vh', background: '#dde2eb', fontFamily: fontStack },
  main: { maxWidth: 1040, margin: '0 auto', padding: '28px 24px' },
  title: { fontSize: 24, fontWeight: 800, color: C.text, margin: '0 0 18px' },
  createRow: { display: 'flex', gap: 10, marginBottom: 24, flexWrap: 'wrap' },
  muted: { color: C.textSoft },
  label: { fontSize: 13, fontWeight: 600, color: '#2e3d52' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 18 },
  cardItem: { background: C.card, border: `1px solid ${C.cardBorder}`, borderRadius: 14, overflow: 'hidden', cursor: 'pointer', boxShadow: '0 2px 10px rgba(13,27,42,.06)' },
  cover: { height: 120, backgroundSize: 'cover', backgroundPosition: 'center' },
  meta: { fontSize: 13, color: C.textSoft, marginTop: 6 },
  publicLink: { display: 'inline-block', marginTop: 10, fontSize: 12, color: C.navy2, textDecoration: 'none', fontWeight: 600 },
}
